import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { inject } from '@angular/core';
import { LoginComponent } from './layouts/components/login/login.component';
import { ContentComponent } from './layouts/content/content.component';
import { ChangePasswordComponent } from './layouts/components/change-password/change-password.component';
import { AuthService } from './services/auth.service';
import { ResetPasswordComponent } from './layouts/components/reset-password/reset-password.component';
import { OtpVerifyComponent } from './layouts/components/otp-verify/otp-verify.component';
import { GaSetupComponent } from './layouts/components/otp-verify/ga-setup/ga-setup.component';
import { GaVerifyComponent } from './layouts/components/otp-verify/ga-verify/ga-verify.component';
import { GaOtpComponent } from './layouts/components/otp-verify/ga-otp/ga-otp.component';
import { GlobalCheckGuard } from './guards/global-check.guard';
import { PermissionGuardGuard } from './guards/permission-guard.guard';
import { AccessDeniedComponent } from './pages/access-denied/access-denied.component';
import { ApprovalComponent } from './pages/approval/approval.component';
const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    pathMatch: 'full',
  },
  {
    path: 'otp',
    component: OtpVerifyComponent,
    pathMatch: 'full',
  },
  {
    path: 'reset-password/:token',
    component: ResetPasswordComponent,
  },
  { path: 'ga-setup', component: GaSetupComponent },
  { path: 'ga-verify', component: GaVerifyComponent },
  { path: 'ga-otp', component: GaOtpComponent },
  // { path: '403', component: AccessDeniedComponent },
  { path: 'approval/public/:id', component: ApprovalComponent },
  {
    path: 'app',
    component: ContentComponent,
    canActivate: [GlobalCheckGuard],
    canActivateChild: [PermissionGuardGuard],
    children: [
      {
        path: 'change-password',
        component: ChangePasswordComponent,
      },
      {
        path: 'attendance',
        loadChildren: () =>
          import('./layouts/components/attendance/attendance.module').then(
            (m) => m.AttendanceModule,
          ),
      },
      {
        path: 'leave',
        loadChildren: () =>
          import('./layouts/Leave/leave.module').then((m) => m.LeaveModule),
      },
      {
        path: 'company',
        loadChildren: () =>
          import('./layouts/components/company/company.module').then(
            (m) => m.CompanyModule,
          ),
      },

      {
        path: 'employee',
        loadChildren: () =>
          import('./layouts/components/employee/employee.module').then(
            (m) => m.EmployeeModule,
          ),
      },
      {
        path: 'organization',
        loadChildren: () =>
          import('./layouts/components/organization/organization.module').then(
            (m) => m.OrganizationModule,
          ),
      },
      {
        path: 'hr',
        loadChildren: () =>
          import('./layouts/components/hr/hr.module').then((m) => m.HrModule),
      },
      {
        path: 'payroll',
        loadChildren: () =>
          import('./layouts/components/payroll/payroll.module').then(
            (m) => m.PayrollModule,
          ),
      },
      {
        path: 'menus',
        loadChildren: () =>
          import('./layouts/components/menus/menus.module').then(
            (m) => m.MenusModule,
          ),
      },
      {
        path: 'tax',
        loadChildren: () =>
          import('./layouts/components/tax/tax.module').then(
            (m) => m.TaxModule,
          ),
      },
      {
        path: 'master',
        loadChildren: () =>
          import(
            /* webpackChunkName: "master" */ './layouts/components/admin/master.module'
          ).then((m) => m.MasterModule),
      },
      {
        path: 'bot',
        loadChildren: () =>
          import('./layouts/components/bot/bot.module').then(
            (m) => m.BotModule,
          ),
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./layouts/reports/reports.module').then(
            (m) => m.ReportsModule,
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
